// extracted by mini-css-extract-plugin
module.exports = {"root":"MyPage_root__AfzmL","tableTitle":"MyPage_tableTitle__3dl77","table":"MyPage_table__1BEMZ","tabsRoot":"MyPage_tabsRoot__nmfkq","tab":"MyPage_tab__DnIW5"};